import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
    mutation AddCartItemMutation(
        $input: ModifyPortfoliosInput!
    ) {
        modifyPortfolios(input: $input) {
            portfolios {
                items {
                    totalResults
                }
            }
        }
    }
`;

function addCartItem({ environment, itemsIds, userId, onCompleted, onError }) {
    return commitMutation(
        environment, {
            mutation,
            variables: {
                input: {
                    action: 'ADD',
                    portfoliosType: 'CART',
                    itemsIds,
                    userId
                }
            },
            onCompleted,
            onError
        }
    );
}

export default { commit: addCartItem };



// WEBPACK FOOTER //
// ./src/components/CartNav/AddCartItemMutation.js